export default __webpack_public_path__ + "static/media/QuickTixWhite.950236be.png";